import angular from 'angular';
import { map } from 'lodash';

module.exports = angular.module('common.filters.map', [])
.filter('map', () => map)
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/map.js
 **/